import { render, staticRenderFns } from "./CourseCodePage.vue?vue&type=template&id=a8a4cd1e&scoped=true"
import script from "./CourseCodePage.vue?vue&type=script&lang=js"
export * from "./CourseCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a4cd1e",
  null
  
)

export default component.exports